module.exports = __webpack_public_path__ + "img/plus_btn.01291a18.png";